export const PasswordComponent = {
    template: `
        <oo-card id="ca-customer-password">
            <oo-card-header>
                <p>Password</p>
            </oo-card-header>

            <oo-card-body>
                <oo-edit-pane on-submit="$ctrl.onSubmit()" on-cancel="$ctrl.resetForm()">
                    <oo-read-state>
                        <p class="text-password" c-type="title-lg-primary">***********</p>

                        <oo-alert ng-if="$ctrl.passwordChangeSuccess" severity="success">
                            <oo-alert-message>Password has been successfully changed</oo-alert-message>
                        </oo-alert>
                    </oo-read-state>

                    <oo-edit-state>
                        <div class="field-group">
                            <input type="password" ng-model="$ctrl.currentPassword" class="field-control" id="user-password-current" name="userCurrentPassword" required/>
                            <label for="user-password-current" class="field-label">Existing Password</label>
                            <p class="field-description">Your current password is required in order to make changes to your password.</p>
                        </div>
                        <div class="field-group">
                            <input type="password" ng-model="$ctrl.newPassword" class="field-control" id="user-password-new" name="userNewPassword" required/>
                            <label for="user-password-new" class="field-label">New Password</label>
                        </div>
                        <div class="field-group">
                            <input type="password" ng-model="$ctrl.newPassword2" class="field-control" id="user-password-verify-new" name="userNewPassword" required/>
                            <label for="user-password-new" class="field-label">Verify New Password</label>
                        </div>

                        <oo-alert ng-if="$ctrl.errorMessage" severity="error">
                            <oo-alert-message>{{$ctrl.errorMessage}}</oo-alert-message>
                        </oo-alert>
                    </oo-edit-state>
                </oo-edit-pane>
            </oo-card-body>
        </oo-card>
    `,
    controller: class {
        constructor($q, AuthenticationService, accountService, restaurantInfoFactory, googleAnalyticsTrackingService) {
            'ngInject';
            this.$q = $q;
            this.authenticationService = AuthenticationService;
            this.accountService = accountService;
            this.restaurantInfoFactory = restaurantInfoFactory;
            this.googleAnalyticsTrackingService = googleAnalyticsTrackingService;
        }
        $onInit() {
            this.restaurantInfoFactory.getInfo(['general'])
                .then(resp => this.restaurantName = resp.general.name);
        }
        resetForm(isSuccess) {
            if (isSuccess) {
                this.googleAnalyticsTrackingService.trackUpdatePassword('success');
            } else {
                this.googleAnalyticsTrackingService.trackUpdatePassword('cancel');
            }

            this.currentPassword = '';
            this.newPassword = '';
            this.newPassword2 = '';
            this.errorMessage = null;
            this.passwordChangeSuccess = false;
        }
        onSubmit() {
            this.errorMessage = this.authenticationService.isValidPassword(this.newPassword, this.newPassword2);
            if (this.errorMessage) {
                return this.$q.reject(this.errorMessage);
            }

            return this.authenticationService
                .updatePassword(
                    this.currentPassword,
                    this.newPassword,
                    this.restaurantName
                ).then(
                    () => {
                        this.resetForm(true);
                        this.passwordChangeSuccess = true;
                    },
                    () => {
                        this.googleAnalyticsTrackingService.trackUpdatePassword('error');

                        this.errorMessage = this.authenticationService.errorMessage;
                        this.passwordChangeSuccess = false;
                        return this.$q.reject(this.errorMessage);
                    }
                );
        }
    }
};
